module.exports = __webpack_public_path__ + "img/user-placeholder.21718df1.png";